import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}
// 认证
export const userCertificationAuth = (data: any) =>
  request.post('/financial/userCertification/auth', data, jsonHeaderConfig)
export const userCertificationBase = (data: any) =>
  request.get('/financial/userCertification/base', data)
export const userAccountAuthDetailNew = (data: any) =>
  request.get('/financial/userAccountAuth/detailNew', data)
// 查询个人资料
export const getQueryInfo = (data?: any) =>
  request.post('/admin/user/profile/query', data, jsonHeaderConfig)
// 修改个人资料
export const updateInfo = (data: any) =>
  request.post('/admin/user/profile/update', data, jsonHeaderConfig)
// 个人认证列表
export const userAuthList = (data: any) =>
  request.post('/financial/userCertification/currentList', data, jsonHeaderConfig)
// 个人暂存
export const userTempSave = (data: any) =>
  request.post('/financial/userCertification/auth/temp', data, jsonHeaderConfig)
// 机构认证
export const identityAuth = (data: any) =>
  request.post('/financial/orgCertification/identity', data, jsonHeaderConfig)
// 查询公司资料
export const getQueryCompanyInfo = (data?: any) =>
  request.get('/admin/tenant/current/detail', data, jsonHeaderConfig)
export const updateCompanyInfo = (data: any) =>
  request.post('/admin/tenant/profile/update', data, jsonHeaderConfig)
// 协议授权
export const agreementChangeApi = (data: any) => request.post('/admin/tenant/agreement', data)

// 机构认证列表
export const companyAuthList = (data: any) =>
  request.post('/admin/tenant/main/current/list', data, jsonHeaderConfig)
// 查看机构详情
export const companyDetail = (data: any) =>
  request.get('/admin/tenant/main/current/detail', data, jsonHeaderConfig)
// 机构认证资料渲染
export const companyDataRender = () =>
  request.get('/financial/orgCertification/render', {}, jsonHeaderConfig)
// 机构暂存
export const tempSave = (data: any) =>
  request.post('/admin/tenant/main/temp', data, jsonHeaderConfig)
// 机构生效
export const enable = (data: any) => request.post('/admin/tenant/effect', data)
// 检测实名认证状态
export const getAccountAuthStatus = (data?: any) =>
  request.post('/financial/userCertification/checkUserAuthStatus', data)
// 修改手机号
export const updatePhone = (data?: any) =>
  request.post('/admin/user/profile/mobile', data, jsonHeaderConfig)
// 修改密码
export const updatePassword = (data?: any) =>
  request.post('/admin/user/profile/password', data, jsonHeaderConfig)
// 检查账号是否重复
export const checkRepeat = (data?: any) =>
  request.get('/admin/user/check/username', data, jsonHeaderConfig)
// 获取账户数量 admin/tenant/saas/queryGrantNum
export const queryGrantNum = (data?: any) =>
  request.post('/admin/tenant/saas/queryGrantNum', data, jsonHeaderConfig)
// 查询印章授权信息
export const sealAuthInfoGet = (data?: any) =>
  request.post('/erp/retailOrganAuth/getOrganAuthInfo', data, jsonHeaderConfig)
// 印章授权
export const sealAuthTwo = (data?: any) =>
  request.post('/erp/retailOrganAuth/sealAuth', data, jsonHeaderConfig)
// 印章查看
export const sealAuthGet = (data?: any) =>
  request.post('/erp/retailOrganAuth/getInfo', data, jsonHeaderConfig)

// 企业授权
export const subAuth = (data?: any) =>
  request.post('/erp/retailOrganAuth/subAuth', data, jsonHeaderConfig)

// 门店是否认证
export const isAuth = (data: any) => request.post('/admin/tenant/isAuth', data, jsonHeaderConfig)
